module.exports = __webpack_public_path__ + "img/ci_3.c0c99987.png";